/**
 * Italian date formatters — uso unico in tutta la webapp.
 * Accetta ISO date strings ("YYYY-MM-DD") o ISO datetime / Date.
 */

function _toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string') {
    const v = value.length === 10 ? `${value}T00:00:00` : value;
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

/** "05/05/2026" — formato classico italiano */
export function dateIT(value) {
  const d = _toDate(value);
  if (!d) return '';
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/** "5 mag 2026" — leggibile, mese abbreviato */
export function dateITShort(value) {
  const d = _toDate(value);
  if (!d) return '';
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** "5 maggio 2026" — formato esteso */
export function dateITLong(value) {
  const d = _toDate(value);
  if (!d) return '';
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
}

/** "ven 5 mag" — settimana + giorno + mese (per task/turni a breve) */
export function dateITDay(value) {
  const d = _toDate(value);
  if (!d) return '';
  return d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
}

/** "5 mag" — solo giorno + mese (compatto, no anno) */
export function dateITDayMonth(value) {
  const d = _toDate(value);
  if (!d) return '';
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
}

/** "5/5/2026, 14:30" — data + ora */
export function dateITWithTime(value) {
  const d = _toDate(value);
  if (!d) return '';
  return d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}
